import { combineReducers } from "redux";
import customFieldsMenu from "./customFieldsMenu";

const customFields = combineReducers({
  customFieldsMenu
});

export default customFields;
